import { render, staticRenderFns } from "./AgroNotification.vue?vue&type=template&id=6229d1e2&"
import script from "./AgroNotification.vue?vue&type=script&lang=ts&"
export * from "./AgroNotification.vue?vue&type=script&lang=ts&"
import style0 from "./agroNotification.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports